import request from '@/util/http';
export default {
    findorderbyid, //通过订单号查询订单
    addorderbyorderid, //通过订单号生成响应归还订单
    getnotreturned, //获取未归还数量
    getdevicesavelist, //存储记录查询
    exportdjgsfcbb,   //导出刀具柜收发存报表
    updateLimitnum, //修改预警数量
}

function updateLimitnum(data) {
    return request({
        url: "user/api/updateLimitnum",
        method: 'post',
        data
    })
}

function exportdjgsfcbb(data) {
    return request({
        url: "excel/api/exportdjgsfcbb",
        method: 'post',
        data,
        responseType: 'blob'
    })
}

function getdevicesavelist(data) {
    return request({
        url: "devicecabinet/api/getdevicesavelist",
        method: 'post',
        data
    })
}

function getnotreturned(data) {
    return request({
        url: "devicecabinet/api/getnotreturned",
        method: 'post',
        data
    })
}

function addorderbyorderid(data) {
    return request({
        url: "devicecabinet/api/addorderbyorderid",
        method: 'post',
        data
    })
}

function findorderbyid(data) {
    return request({
        url: "devicecabinet/api/findorderbyid",
        method: 'post',
        data
    })
}